import { render } from "./VualaVistaView.vue?vue&type=template&id=6dd035d0"
import script from "./VualaVistaView.vue?vue&type=script&lang=js"
export * from "./VualaVistaView.vue?vue&type=script&lang=js"

import "./VualaVistaView.vue?vue&type=style&index=0&id=6dd035d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__